import { addDoc, collection, getDocs, query, where } from 'firebase/firestore';
import { AppointmentRepository } from '../../../domain/contracts/repositories';
import { Appointment } from '../../../domain/entities';
import db from '../../../setup/firebase/firebase';
import { FirebaseAppointment } from '../entities';
import { AppointmentMapper } from '../mappers';

export class FirebaseAppointmentRepository implements AppointmentRepository {
  COLLECTION_PATH = 'appointments';

  async findAll(): Promise<Appointment[]> {
    const querySnapshot = await getDocs(collection(db, this.COLLECTION_PATH));
    const appointments = querySnapshot.docs.map((doc) => {
      const data = doc.data() as FirebaseAppointment;
      data.id = doc.id;
      return AppointmentMapper.toDomain(data);
    });
    return appointments;
  }

  async findByDoctor({
    doctorId,
    fromNow = false
  }: {
    doctorId: string;
    fromNow?: boolean;
  }): Promise<Appointment[]> {
    const queryConstraints = [where('doctor.id', '==', doctorId)];
    if (fromNow) queryConstraints.push(where('endDate', '>', new Date()));

    const q = query(collection(db, this.COLLECTION_PATH), ...queryConstraints);
    const querySnapshot = await getDocs(q);
    const appointments = await Promise.all(
      querySnapshot.docs.map(async (doc) => {
        const data = doc.data();
        data.id = doc.id;
        return data as FirebaseAppointment;
      })
    );
    return appointments.map((appointment) => AppointmentMapper.toDomain(appointment));
  }

  async create(appointment: Appointment): Promise<void> {
    await addDoc(collection(db, this.COLLECTION_PATH), appointment);
  }
}
